import { c as _c } from "react/compiler-runtime";
import { type Post } from '@shared/all/domains/posts';
import { useEffect, useRef } from 'react';
import useDatabase from '../hooks/useDatabase';
import useMoodTracking from '../hooks/useMoodTracking';
type UsePostEngagementTrackerOptions = {
  post: Post;
  externalIsInView: boolean;
  isFocused?: boolean;
};
const usePostEngagementTracker = t0 => {
  const $ = _c(17);
  const {
    post,
    externalIsInView,
    isFocused: t1
  } = t0;
  const isFocused = t1 === undefined ? true : t1;
  const {
    addOrUpdatePostEngagement,
    isReady,
    canWrite
  } = useDatabase();
  const {
    reportFactiiiEngagement,
    moodTrackingEnabled
  } = useMoodTracking();
  const intervalRef = useRef(null);
  let t2;
  if ($[0] !== addOrUpdatePostEngagement || $[1] !== canWrite || $[2] !== externalIsInView || $[3] !== isFocused || $[4] !== isReady || $[5] !== moodTrackingEnabled || $[6] !== post || $[7] !== reportFactiiiEngagement) {
    t2 = () => {
      const isActive = externalIsInView && isFocused;
      if (isActive) {
        intervalRef.current = setInterval(() => {
          if (!post?.id) {
            return;
          }
          if (isReady && canWrite !== false) {
            addOrUpdatePostEngagement(post, 3, new Date());
          }
          if (moodTrackingEnabled && post.postFactiiisCount?.length) {
            for (const factiii of post.postFactiiisCount) {
              reportFactiiiEngagement(factiii.factiiiId, 3);
            }
          }
        }, 3000);
      } else {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
        }
      }
      return () => {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
        }
      };
    };
    $[0] = addOrUpdatePostEngagement;
    $[1] = canWrite;
    $[2] = externalIsInView;
    $[3] = isFocused;
    $[4] = isReady;
    $[5] = moodTrackingEnabled;
    $[6] = post;
    $[7] = reportFactiiiEngagement;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== canWrite || $[10] !== externalIsInView || $[11] !== isFocused || $[12] !== isReady || $[13] !== moodTrackingEnabled || $[14] !== post || $[15] !== reportFactiiiEngagement) {
    t3 = [externalIsInView, isFocused, post, isReady, canWrite, moodTrackingEnabled, reportFactiiiEngagement];
    $[9] = canWrite;
    $[10] = externalIsInView;
    $[11] = isFocused;
    $[12] = isReady;
    $[13] = moodTrackingEnabled;
    $[14] = post;
    $[15] = reportFactiiiEngagement;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  useEffect(t2, t3);
};
export default usePostEngagementTracker;